import avatar from './avatar.webp'
import logo from './logo.webp'
import logo2 from './logo-2.webp'
import logo3 from './logo-3.webp'
import logo4 from './logo-4.webp'
import nextjs from './nextjs.png'
import tailwind from './tailwind.png'
import thumbnailDefault from './thumbnail-default.webp'
const images = {
    avatar,
    logo,
    logo2,
    logo3,
    logo4,
    nextjs,
    tailwind,
    thumbnailDefault,
}
export default images
